// extracted by mini-css-extract-plugin
export default {"content":"ContactDetailsPage_content__gIpd0","title":"ContactDetailsPage_title__OGD64"};